import { useEffect } from "react";
import { Link } from "react-router-dom";
import LogoFull from "../assets/LogoFull.png";
import ThankYouBg from "../assets/Home/ThankYouBg.png";
import "./LeadMagnet.css";

export default function HomeMaintenanceAssessmentThankYou() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex,nofollow";
    document.head.appendChild(meta);
    return () => document.head.removeChild(meta);
  }, []);

  return (
    <div className="min-h-screen flex flex-col font-sans bg-white">
      <header className="bg-white border-b border-gray-200 py-3 px-6 flex justify-center">
        <img src={LogoFull} alt="PropertEasy" className="h-14 w-auto" />
      </header>

      <section
        className="relative flex items-center justify-center px-6 flex-1"
        style={{
          backgroundImage: `url(${ThankYouBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "560px",
        }}
      >
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(0, 0, 0, 0.60)" }} />

        <div className="relative z-10 max-w-2xl mx-auto text-center">
          <h1
            className="mb-8"
            style={{ color: "#52C271", fontFamily: "Catamaran, sans-serif", fontSize: "48px", fontWeight: 700, lineHeight: 1.1 }}
          >
            Your Assessment Request Is In!
          </h1>

          <p
            className="text-white mb-6"
            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif", fontSize: "28px", fontWeight: 400, lineHeight: "1.25" }}
          >
            Thanks for reaching out. A Properteasy professional will review your details and follow up with helpful next steps for your property.
          </p>

          <p
            className="text-white mb-10"
            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif", fontSize: "22px", fontWeight: 400, lineHeight: "1.35" }}
          >
            Scheduling will be handled personally for now, so there is no need to choose a time online.
          </p>

          <Link
            to="/home-maintenance-assessment"
            className="inline-block text-white font-semibold px-10 py-4 rounded"
            style={{ backgroundColor: "#52C271", fontSize: "16px" }}
          >
            Back to Assessment Page
          </Link>
        </div>
      </section>
    </div>
  );
}
